import { toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { Subject } from 'rxjs';

export class HtmlToPdf {
  doneEvent: Subject<any>;

  constructor() {
    this.doneEvent = new Subject();
  }

  createCanvasFromId(pageId: string, nameOfPdf: string) {
    const element = document.querySelector('#' + pageId) as HTMLElement;

    if (!element) {
      console.error(`Element #${pageId} not found`);
      this.doneEvent.next(true);
      this.doneEvent.complete();
      return;
    }

    const divHeight = element.scrollHeight;
    const divWidth = element.scrollWidth;
    const ratio = divHeight / divWidth;

    toPng(element, {
      cacheBust: true,
      width: divWidth,
      height: divHeight,
      canvasHeight: divHeight,
      canvasWidth: divWidth,
      filter: (node) => {
        return node.getAttribute?.('data-pdf-ignore') !== 'true';
      }
    })
      .then((dataUrl) => {
        this.getPDF(ratio, dataUrl, nameOfPdf);
      })
      .catch((e) => {
        console.error('html-to-image error:', e);
        this.doneEvent.next(true);
        this.doneEvent.complete();
      });
  }

  getPDF(ratio: number, dataUrl: string, nameOfPdf: string) {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const imgWidth = pageWidth - 20;
    const imgHeight = ratio * imgWidth;

    let remainingHeight = imgHeight;
    let yOffset = 0;

    while (remainingHeight > 0) {
      doc.addImage(dataUrl, 'PNG', 10, -yOffset, imgWidth, imgHeight);
      remainingHeight -= pageHeight;
      if (remainingHeight > 0) {
        yOffset += pageHeight;
        doc.addPage();
      }
    }

    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nameOfPdf + '.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    this.doneEvent.next(true);
    this.doneEvent.complete();
  }
}